import { render, staticRenderFns } from "./DepartmentsSelectBox.vue?vue&type=template&id=f8a4aa1e&scoped=true&"
import script from "./DepartmentsSelectBox.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a4aa1e",
  null
  
)

export default component.exports